<template>
  <Tabs
      :class="['zpa-column', 'zpa-tabs', fit && 'fit', topbar && 'topbar']"
      @on-click="click"
      :name="name"
      :style="style"
      :animated="animated"
      :type="type"
      :size="size"
      :closable="closable"
      :value="value"
      @input="val => $emit('input', val)"
  >
    <TabPane
        v-for="(tab, index) in tabData"
        :key="index + reload"
        :label="tab.render || tab.name"
        :disabled="tab.disabled"
        :name="tab.component"
        :tab="name"
    >
      <template v-if="!inForm">
        <slot :name="tab.component"></slot>
      </template>
      <template v-else>
        <FormDiv
            v-if="tab.resolved"
            :modelId="tab.formId"
            :row="row"
            :access="tab.access || {}"
        />
        <Spin v-else />
      </template>
    </TabPane>
    <span slot="extra">
      <slot name="extra"></slot>
    </span>
  </Tabs>
</template>
<script>
export default {
  name: 'TabList',
  data() {
    return {
      reload: '',
    }
  },
  props: {
    fit: Boolean,
    topbar: Boolean,
    name: String,
    value: String,
    tabData: Array,
    height: String,
    noFlex: Boolean,
    animated: Boolean,
    type: String,
    size: String,
    closable: Boolean,
    inForm: Boolean,
    keepalive: Boolean,
    // 与自定义表单对接
    context: Object,
  },

  computed: {
    style() {
      if (!this.noFlex) {
        return {
          height: this.height ? `${this.height}px` : undefined,
        }
      }
      return {
        height: this.height ? `${this.height}px` : undefined,
        flex: 'none',
      }
    },

    row() {
      return this.context ? this.context.data : {}
    },
  },

  methods: {
    click(name) {
      this.active(name)
      this.$slots[name][0].componentInstance.reload()
      this.$emit('click', name)
    },

    clear() {
      this.tabData.forEach(t => {
        t.resolved = false
      })
    },

    active(name) {
      let index = 0
      for (let i = 0; i < this.tabData.length; i++) {
        const tab = this.tabData[i]
        if (name === tab.component) {
          index = i
          break
        }
      }

      // 其他tab不需要加载
      this.clear()
      this.refresh()
      const tab = this.tabData[index]
      this.resolve(tab, index)
    },

    resolve(tab, index) {
      setTimeout(() => {
        tab.resolved = true
        this.$set(this.tabData, index, tab)
        this.refresh()
      }, 100)
    },

    refresh() {
      if (!this.keepalive) {
        this.reload = new Date().getTime()
      }
    },
  },

  created() {
    this.clear()
  },

  mounted() {
    this.active()
  },
}
</script>
<style lang="less">
.zpa-tabs {
  display: flex;
  flex-direction: column;
  overflow: visible;

  .ivu-tabs-bar {
    margin-bottom: 8px;
  }

  .ivu-tabs-content {
    flex: none;
  }

  .ivu-tabs-tabpane {
    display: flex;
    flex-direction: column;
  }
}
.topbar .ivu-tabs-bar {
  position: fixed;
  top: 64px;
  left: 50%;
  transform: translateX(-50%);
}
.fit {
  .ivu-table-header {
    position: relative;
  }
  .ivu-table-tip {
    height: 100% !important;
    margin-top: -32px;
  }
  .ivu-table-fixed-right {
    height: 100%;
    background-color: #fff;
  }

  .ivu-table-body {
    min-height: calc(100% - 37px);
  }

  .ivu-tabs-content,
  .ivu-tabs-tabpane,
  .ivu-table-tip table,
  .ivu-table-fixed,
  .ivu-table-wrapper {
    height: 100%;
  }
}
/*表单设置了高度自适应 ，*/
.height-auto{
  .zpa-tabs {
    height: 100%;
    display: flex;

    .ivu-tabs-content {
      flex: auto;

      .ivu-tabs-tabpane {
        height: 100%;
      }
    }
  }
}
</style>
